// components/settings/OtherSection.jsx
import Typography from "../../components/Typography/Typography";
import InfoBlock from "./InfoBlock";

const OtherSection = ({ userData, handleFieldUpdate }) => {
  return (
    <div className="w-full flex flex-col gap-4">
      <Typography size="20" weight="sb">La tua tesi</Typography>
      {userData && (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
          <InfoBlock
            title="Campo di studio"
            content={userData.StudyField}
            onChange={(val) => handleFieldUpdate("StudyField", val)}
          />
          <InfoBlock
            title="Tipo di tesi"
            content={userData.ThesisType}
            onChange={(val) => handleFieldUpdate("ThesisType", val)}
          />
          <InfoBlock
            title="Tempo rimanente"
            content={userData.DueRemainingTime}
            onChange={(val) => handleFieldUpdate("DueRemainingTime", val)}
          />
          <InfoBlock
            title="Argomento tesi"
            content={userData.ThesisPrompt}
            onChange={(val) => handleFieldUpdate("ThesisPrompt", val)}
          />
          {userData.ExtraInfo && (
            <InfoBlock
              title="Informazioni aggiuntive"
              content={userData.ExtraInfoText}
              onChange={(val) => handleFieldUpdate("ExtraInfoText", val)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default OtherSection;